import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
  },

  actionContainer: {
    alignItems: 'center',
    width: '100%',
  },

  draggable: {
    margin: `${theme.spacing(1.2)} ${theme.spacing(0)} ${theme.spacing(
      2,
    )} ${theme.spacing(0)}`,
  },
})
